import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "body"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "table table-striped" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  class: "table table-fixed table-striped",
  style: {"max-width":"720px"}
}
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "table table-fixed table-striped",
  style: {"max-width":"720px"}
}
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "mt-5 mw-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_accordion = _resolveComponent("accordion")!
  const _directive_date = _resolveDirective("date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Gestione orari prenotazione",
          text: "Gestione orari prenotazione"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Seleziona professione",
          text: "Seleziona professione"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProfessione) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professioni, (item, i) => {
          return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item.name), 9, _hoisted_4))
        }), 256))
      ], 512), [
        [_vModelSelect, _ctx.selectedProfessione]
      ])
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)),
    (_ctx.config)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Numero giorni preavviso",
                text: "Numero giorni preavviso"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.calendarConfig.advanceNoticeDays) = $event))
            }, null, 512), [
              [_vModelText, _ctx.config.calendarConfig.advanceNoticeDays]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Numero giorni di distacco dalla visita precedente",
                text: "Numero giorni di distacco dalla visita precedente"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.calendarConfig.daysSinceLastBooking) = $event))
            }, null, 512), [
              [_vModelText, _ctx.config.calendarConfig.daysSinceLastBooking]
            ])
          ]),
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Orari della settimana",
                  text: "Orari della settimana"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.calendarConfig.weeklyTimeTable.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Giorno",
                        text: "Giorno"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Slot orari",
                        text: "Slot orari"
                      }),
                      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_localized_text, {
                        localizedKey: "(selezionabili per appuntamento)",
                        text: "(selezionabili per appuntamento)"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addOrarioPrenotazione && _ctx.addOrarioPrenotazione(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.calendarConfig.weeklyTimeTable, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((item.dayOfTheWeek) = $event)
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("option", {
                            value: null,
                            disabled: ""
                          }, "Giorno", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (i, day) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: i,
                              value: i
                            }, _toDisplayString(day), 9, _hoisted_11))
                          }), 128))
                        ], 8, _hoisted_10), [
                          [_vModelSelect, item.dayOfTheWeek]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success",
                            onClick: ($event: any) => (_ctx.addFasciaOraria(item))
                          }, "+", 8, _hoisted_13)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.timeTable, (fascia, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex align-items-center justify-content-around",
                            key: i
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              "onUpdate:modelValue": ($event: any) => ((fascia.from) = $event)
                            }, null, 8, _hoisted_14), [
                              [_vModelText, fascia.from]
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "time",
                              "onUpdate:modelValue": ($event: any) => ((fascia.to) = $event)
                            }, null, 8, _hoisted_15), [
                              [_vModelText, fascia.to]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (_ctx.removeFascia(fascia, item.timeTable))
                            }, "-", 8, _hoisted_16)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.removeOrarioPrenotazione(item))
                        }, "- rimuovi giorno", 8, _hoisted_18)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Giorni da escludere",
                  text: "Giorni da escludere"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.calendarConfig.daysToExclude.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_19, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Giorno",
                        text: "Giorno"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Mese",
                        text: "Mese"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addGiornoDaEscludere && _ctx.addGiornoDaEscludere(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.calendarConfig.daysToExclude, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "Giorno (numero)",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.day) = $event)
                        }, null, 8, _hoisted_21), [
                          [_vModelText, item.day]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          placeholder: "Mese (numero)",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.month) = $event)
                        }, null, 8, _hoisted_22), [
                          [_vModelText, item.month]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.config.calendarConfig.daysToExclude.splice(i, 1))
                        }, "-", 8, _hoisted_24)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
          _createVNode(_component_accordion, null, {
            title: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Periodi da escludere",
                  text: "Periodi da escludere"
                }),
                _createTextVNode(" (" + _toDisplayString(_ctx.config.calendarConfig.periodsToExclude.length) + ") ", 1)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("table", _hoisted_25, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Inizio",
                        text: "Inizio"
                      })
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Fine",
                        text: "Fine"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addPeriodoDaEscludere && _ctx.addPeriodoDaEscludere(...args)))
                      }, "+")
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.calendarConfig.periodsToExclude, (item, i) => {
                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.from) = $event)
                        }, null, 8, _hoisted_27), [
                          [_directive_date, item.from],
                          [_vModelText, item.from]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.to) = $event)
                        }, null, 8, _hoisted_28), [
                          [_directive_date, item.to],
                          [_vModelText, item.to]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: ($event: any) => (_ctx.config.calendarConfig.periodsToExclude.splice(i, 1))
                        }, "-", 8, _hoisted_30)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-block btn-primary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ok && _ctx.ok(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "OK",
                text: "OK"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}